import React from 'react';
import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import PlayersGroupExclusionSwitcher from './players-group-exclusion-switcher';

class PlayersGroupExclusionSwitchersList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isActive: false,
        };
    }

    onClick(isActive) {
        this.setState({isActive});
    }

    isAtLeastOneExcludedAnywhere() {
        const {players, playersExclusion} = this.props;
        for (let player of players) {
            if (playersExclusion.isExcludedAnywhere(player.getId())) {
                return true;
            }
        }
        return false;
    }

    render() {
        const {players, modesConfig} = this.props;

        const modes = modesConfig.all({asArr: true});
        const isActive = this.state.isActive;
        const isExcludedAnywhere = this.isAtLeastOneExcludedAnywhere();

        return (
            <div className={`checkbox-btn-holder${isActive ? ' active' : ''}`}>
                <button
                    type="button"
                    className={`checkbox-btn${!isExcludedAnywhere ? ' active' : ''}`}
                    onClick={() => this.onClick(!isActive)}
                    title={
                        isExcludedAnywhere ? 'Disable exclusion for all players' : 'Enable exclusion for all players'
                    }
                >
                    {isExcludedAnywhere ? 'Disable exclusion for all players' : 'Enable exclusion for all players'}
                </button>
                <ul className="checkbox-btn-drop">
                    {modes.map((mode) => {
                        return (
                            <li key={mode.getRole()} onClick={() => this.onClick(!isActive)}>
                                <PlayersGroupExclusionSwitcher players={players} activeMode={mode.getRole()} />
                                <div>{mode.getLabel()}</div>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {sportConfig, modesConfig, playersExclusion} = state;
    return {
        sportConfig,
        modesConfig,
        playersExclusion,
    };
}

export default connect(mapStatesToProps)(PlayersGroupExclusionSwitchersList);
